export default "__VITE_ASSET__9e2e3b96__"